<template>
  <div class="wrapper layout column">
    <div class="header mb-2 layout align-center">
      <div class="layout align-center">
        <v-chip small>
          Master
        </v-chip>
        &#8674;
        <v-chip color="primary" small>
          {{ targetCountry }}
        </v-chip>
      </div>
    </div>
    <div v-if="finalItems.length > 0" class="content">
      Your are localizing: <br />
      <v-list class="list">
        <v-list-item v-for="slide in finalItems" :key="slide._id" class="slide">
          <v-list-item-avatar tile>
            <v-img :src="slide.asset.public.png" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ slide.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ slide.externalId }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div v-if="type === 'chapter' || type === 'flow'">
        <!--	TODO: HERE WHEN USING FLOW -->
      </div>
    </div>
    <div v-else>
      Noting selected for localization.
    </div>
    <div v-if="job" class="jobs">
      <div v-for="stage in job.stages">
        <div class="stage mb-1 d-inline-flex">
          <div>{{ stage.name.replace('.', ' ') }}</div>
          ....
          <v-spacer />
          <v-chip :style="chipColor(stage.status)" small class="justify-self-end">
            {{ stage.status.replace('_', ' ').toUpperCase() }}
          </v-chip>
        </div>
      </div>
      <v-divider />
      <div class="layout mt-5 justify-space-between">
        <div>Status:</div>
        <v-chip :style="chipColor(job.status)" small>
          {{ job.status.replace('_', ' ').toUpperCase() }}
        </v-chip>
      </div>
    </div>
    <div class="actions mt-3 layout align-end justify-end">
      <core-button
        :is-loading="isLocalizing"
        :disabled="finalItems.length === 0 || isLocalizing"
        label="Localize now"
        not-rounded
        flat
        @click.stop="startLocalizing"
      />
      <core-button
        v-show="job && job.status === 'success'"
        label="Done"
        not-rounded
        flat
        @click.stop="endLocalization(false)"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CoreButton from '../../core/buttons/CoreButton';
import localization from '@/mixins/localization-mixin';
import gql from 'graphql-tag';

export default {
  name: 'FinishLocalization',
  components: { CoreButton },
  mixins: [localization],
  data() {
    return {
      isLocalizing: false,
      jobId: null,
      job: null
    };
  },
  watch: {
    'job.status': {
      handler(o) {
        if (o === 'error' || o === 'success') {
          this.isLocalizing = false;
          if (o === 'success') {
            this.$store.dispatch(
              'alerts/success',
              `You sucessfully copied ${finalItems.length} slides to your library.`
            );
          }
        }
      }
    }
  },
  methods: {
    chipColor(status) {
      switch (status) {
        case 'in_progress':
          return {
            backgroundColor: ''
          };
        case 'success':
          return {
            backgroundColor: 'green'
          };
        case 'error':
          return {
            backgroundColor: 'red'
          };
      }
    },
    async startLocalizing() {
      this.isLocalizing = true;
      try {
        const job = await this.duplicate();
        if (job) {
          this.jobId = job._id;
        }
      } catch (e) {
        this.isLocalizing = false;
        this.$store.dispatch('alerts/warning', 'Not able to create localization');
      }
    }
  },
  apollo: {
    job: {
      query: gql`
        query($id: String) {
          getJob(id: $id) {
            _id
            status
            stages {
              name
              status
            }
          }
        }
      `,
      skip() {
        return !this.isLocalizing || !this.jobId;
      },
      update: data => data.getJob,
      pollInterval: 500,
      variables() {
        return {
          id: this.jobId
        };
      }
    }
  },
  computed: {
    ...mapState('localization', {
      targetCountry: ({ localization }) => localization.targetCountry,
      finalItems: ({ localization }) => localization.slides.finalItems,
      type: ({ localization }) => localization.type
    })
  }
};
</script>

<style scoped>
.wrapper {
}

.jobs {
  width: 100%;
}
.jobs .stage {
  width: 100%;
}
.list {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
